import { render, staticRenderFns } from "./courseVideo.vue?vue&type=template&id=1e6275da&scoped=true"
import script from "./courseVideo.vue?vue&type=script&lang=ts"
export * from "./courseVideo.vue?vue&type=script&lang=ts"
import style0 from "./courseVideo.vue?vue&type=style&index=0&id=1e6275da&prod&lang=scss"
import style1 from "./courseVideo.vue?vue&type=style&index=1&id=1e6275da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6275da",
  null
  
)

export default component.exports